<template>
    <section>
        <v-container class="nav">
            <v-btn icon class="black--text" @click="$router.go(-1)">
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiFileDocument }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Annual Check Up Approval
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- End App Bar -->
        <v-container style="width:90%; margin:auto">
            <div v-if="apeData">
                <div v-if="apeData.eligible == true">
                    <h2> Annual Check Up Request Terms of Service</h2>
                    <p>
                        You can now request an approval instantly for an annual check-up at HMI Care Clinic or at designated clinic.
                        Please note that this feature is for <b>ANNUAL CHECK UP ONLY</b>. Your request may be denied if the system has found that your account has any of, but not limited to, the following reasons:
                        <br><br>
                        <ul>
                            <li>Your account has expired, has lapsed, or is cancelled.</li>
                            <li>You have outstanding bills to pay with HMI.</li>
                            <li>You have exceeded your maximum benefit limit within the contract term.</li>
                        </ul>
                        <br>
                        Moreover, note that your online requests are automatically added to your utilization records. You may only use this feature <b>once until the next annual renewal of your membership</b>. If you have any concerns, please contact <a href="https://www.hmi.com.ph/contact">HMI</a>.
                    </p>
                    <h1>Quick Instructions</h1>
                    <p>
                        <ol>
                            <li>Click the "Request For Approval" button below.</li>
                            <li>Check if your information in our system is correct as shown on the first section of the form.</li>
                            <li>Select the HMICARE Clinic Branch or your designated HMI affiliated clinic which you wish to have an appointment for an Annual Check Up.</li>
                            <li>Click submit and wait for the results of the automated adjudication on your request.</li>
                            <li>If your request is approved, check your email (the one your registered on HMI Portal) for your approved eOPAN. You may also print the eOPAN by clicing "DOWNLOAD" on the results page or by going to the History page. If your request is denied, please call HMI.</li>
                        </ol>
                    </p>
                    <div style="background-color: white; padding: 3px; border-radius: 5px;">
                        <v-alert
                            color="teal darken-4"
                            outlined
                            style="margin: 0;"
                            type="info"
                        >
                            <span><strong>Disclaimer: </strong>The approval for the referenced service or treatment is provisional. If, upon further review, it is determined that the service or treatment is not eligible for coverage under your health card plan, you may be billed back for any or all costs incurred.</span>
                        </v-alert>
                    </div>
                    <p>
                        <v-checkbox
                            v-model="read_terms"
                            label="I have read and understood the Terms of Service and Instructions."
                        />
                    </p>
                </div>
                <div v-else>
                    <div class="error_message">
                        We are unable to schedule your Annual Check Up at this time. This is due to the following reason:
                        <v-alert
                            type="info"
                            outlined
                            color="teal darken-3"
                            style="margin: 10px 0"
                        >
                            <span style="color: black; font-weight: 600;">{{ message }}</span>
                        </v-alert>
                    </div>
                    <div v-if="String(message).includes('You already have a pending appointment')" class="error_message">
                        If you were not able to avail of your Annual Check-Up during the validity of this approval number, you may request revalidation <strong>once</strong>, to adjust its validity period.
                        <v-container class="requestWrapper">
                            <v-btn class="teal white--text" @click="$router.push(`/dashboard/annual-physical-exam/revalidate`)">
                                <h1>Revalidate Approval</h1>
                            </v-btn>
                        </v-container>
                    </div>
                    <div class="error_message">
                        <strong>For further inquiries:</strong> Please contact HMI directly at (02) 8811-1313, (02) 7752-0552, (02) 8865-3700, 0999-993-4895 and 0917-853-3705.
                    </div>
                </div>
            </div>
        </v-container>
        <!-- End Instructions -->
        <div v-if="apeData && apeData.eligible == true">
            <v-container class="requestWrapper">
                <v-btn :disabled="!read_terms" class="teal white--text" @click="$router.push(`/dashboard/annual-physical-exam/request`)">
                    <h1>Request for Approval</h1>
                </v-btn>
            </v-container>
        </div>
    </section>
</template>

<script>
import { mdiArrowLeft, mdiFileDocument } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
export default {
    data: () => {
        return({
            mdiArrowLeft,
            mdiFileDocument,
            apeData: null,
            message: '',
            read_terms: false
        })
    },
    computed: {
        ...mapGetters(['getEligibilityAPE'])
    },
    watch: {
        getEligibilityAPE(newVal) {
            if (newVal) this.apeData = newVal
        }
    },
    async mounted() {
        try {
            const ape_status = await this.get_ape_status()
            if (ape_status.eligible === false) {
                this.message = ape_status.message
            }
        } catch (error) {
        // console.error(error);
        }
    },
    destroyed() {
        this.apeData = null
    },
    methods: {
        ...mapActions(['getCsrfToken']),
        ...mapActions(['getCsrfToken', 'isEligibleForAPE']),
        async get_ape_status() {
            await this.isEligibleForAPE({ MEMBN: this.$cookies.get('usermembn') })
            const ape_status = this.getEligibilityAPE // Retrieve updated state
            return ape_status
        }
    }
}
</script>

<style scoped>
.requestWrapper {
    height: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}

.error_message {
  margin-top: 20px;
}

.error_message p {
  margin-top: 10px;
  font-weight: 600;
}

section {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.user-card {
  width: 95%;
}

h1 {
    font-size: 18px;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
